// src/com/auto_plan_bind/AutoPlanBindGql.js
import { gql } from "@apollo/client";

/*

extend type Mutation {
    autoPlanBindBuild(autoPlanBind: InputAutoPlanBindBuild!): CommonResponse! # 자동배차 동적 생성.
    autoPlanBindListBound(planDate:String!, storeId:String!): [AutoPlanBind]!
    autoPlanBindClear(autoPlanBind: InputAutoPlanBindClear!): CommonResponse! # 자동배차 동적 일괄 삭제.
}
input InputAutoPlanBindBuild {
	planDate: String!
}

input InputAutoPlanBindClear {
	planDate: String!
}

type AutoPlanBind {
	dcCd: String!
	planDate: String!
	bindIndex: Int!
	targetStoreId: String!
	targetHocha: Int
	bindStoreId: String
	bindHocha: Int
	regDate: String
	regUser: String
	regUserName: String
}

*/

const AUTO_PLAN_BIND_LIST_PART = gql`
fragment AutoPlanBindListPart on AutoPlanBind {
    dcCd
    planDate
    bindIndex
    targetStoreId
    targetHocha
    bindStoreId
    bindHocha
    regDate
    regUser
    regUserName
}
`;

// 동적으로 묶여있는 배차 목록 조회. 그러나 2개 이상이면 뭔가 이상한 것.
export const LIST_AUTO_PLAN_BIND = gql`
${AUTO_PLAN_BIND_LIST_PART}
query ListAutoPlanBind($planDate:String!, $storeId:String!) {
    autoPlanBindList(planDate:$planDate, storeId:$storeId) {
        ...AutoPlanBindListPart
    }
}
`;


export const BUILD_AUTO_PLAN_BIND = gql`
mutation BuildAutoPlanBind($autoPlanBind: InputAutoPlanBindBuild!) {
    autoPlanBindBuild(autoPlanBind: $autoPlanBind) {
        ok
        message
    }
}
`;

export const CLEAR_AUTO_PLAN_BIND = gql`
mutation ClearAutoPlanBind($autoPlanBind: InputAutoPlanBindClear!) {
    autoPlanBindClear(autoPlanBind: $autoPlanBind) {
        ok
        message
    }
}
`;

export const SAVE_AUTO_PLAN_BIND = gql`
mutation SaveAutoPlanBind($autoPlanBind:InputAutoPlanBindSave!) {
	autoPlanBindSave(autoPlanBind: $autoPlanBind) {
		ok
		message
	}
}
`;

export const REMOVE_AUTO_PLAN_BIND = gql`
mutation RemoveAutoPlanBind($autoPlanBind:InputAutoPlanBindRemove!) {
	autoPlanBindRemove(autoPlanBind: $autoPlanBind) {
		ok
		message
	}
}
`;
